import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";

const StyledInputWrapper = styled.div`
  position: relative;
`;

const StyledInput = styled.input`
  position: absolute;
  top: 5px;
  left: 3px;
  margin: 0;
  padding: 0;
  height: auto;
  width: auto !important;

  &:checked + label {
    &:before {
      border-color: ${props => props.theme.checkbox};
      background-color: ${props => props.theme.checkbox};
    }
    &:after {
      opacity: 1;
    }
  }
`;

const StyledLabel = styled.label`
  transition: color 0.2s ease-in-out;
  padding-left: 22px;
  vertical-align: middle;
  color: ${props => props.theme.textLight};
  cursor: pointer;
  user-select: none;
  font-size: 14px;

  &:before {
    transition: border-color 0.2s ease-in-out;
    position: absolute;
    content: "";
    width: 14px;
    height: 14px;
    left: 0;
    top: 3px;
    border-radius: 2px;
    background-color: #ffffff;
    border: 1px solid ${props => props.theme.checkbox};
  }

  &:after {
    transition: opacity 0.2s ease-in-out;
    position: absolute;
    content: "";
    width: 12px;
    height: 9px;
    left: 2px;
    top: 6px;
    background-repeat: no-repeat;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDc4LjMgNTQuMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzguMyA1NC4xOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLC05NTIuMzYyMTgpIj48cGF0aCBjbGFzcz0ic3QwIiBkPSJNNzEuMSw5NTIuNGMtMS44LDAuMS0zLjUsMC44LTQuOCwyLjFsLTM1LjYsMzUuNkwxMS41LDk3NWMtMi45LTIuNS03LjQtMi4yLTkuOSwwLjhzLTIuMiw3LjQsMC44LDkuOWMwLjEsMC4xLDAuMywwLjIsMC40LDAuM2wyNCwxOWMyLjgsMi4yLDYuOCwyLDkuMy0wLjVsNDAtNDBjMi44LTIuNywyLjktNy4xLDAuMi05LjlDNzQuOSw5NTMuMSw3Myw5NTIuMyw3MS4xLDk1Mi40TDcxLjEsOTUyLjR6Ii8+PC9nPjwvc3ZnPg==);
    opacity: 0;
  }
`;

const InputCheckbox = ({ label, id, children, className, ...restProps }) => (
  <StyledInputWrapper className={className}>
    <StyledInput type="checkbox" id={id} {...restProps} />
    <StyledLabel htmlFor={id}>{label}</StyledLabel>
    {children}
  </StyledInputWrapper>
);

export default InputCheckbox;
